<template>
  <div class="flex justify-center">
    <div
      class="grid-view-container h-auto sm:h-full grid grid-cols-2 gap-1 lg:gap-3 md:grid-cols-5 sm:w-8/12"
    >
      <template v-for="(video, index) in getVideoGridView">
        <PreviewComponent :video="video" :index="index" :key="index" />
      </template>
    </div>
  </div>
</template>

<style scoped>
.grid-view-container {
}

.grid-view-container::-webkit-scrollbar {
  display: none;
}
</style>

<script>
import { mapGetters } from "vuex";

// Components
import PreviewComponent from "../components/PreviewComponent";

/* https://bost.ocks.org/mike/shuffle/ */
function shuffle(array) {
  var m = array.length,
    t,
    i;

  // While there remain elements to shuffle…
  while (m) {
    // Pick a remaining element…
    i = Math.floor(Math.random() * m--);

    // And swap it with the current element.
    t = array[m];
    array[m] = array[i];
    array[i] = t;
  }

  return array;
}

export default {
  name: "GridView",
  components: { PreviewComponent },
  computed: {
    ...mapGetters(["getVideos"]),
    getVideoGridView() {
      const videos = this.getVideos;

      return shuffle(videos);
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    responsiveWindow() {},
  },
};
</script>
